import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { AdminService } from './../../_services/admin.service';
@Component({
  selector: 'app-admin-home-show',
  templateUrl: './admin-home-show.component.html',
  styleUrls: ['./admin-home-show.component.css']
})
export class AdminHomeShowComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  managementItems=[
    ["Curriculum","/admin/curriculum/index"],
    ["Syllabus","/admin/syllabus/index"],
    ["Sub Topics All","/admin/subTopic/index"],
    ["Invoices","/admin/invoice/index"],
    ["Accounts","/admin/account/receivable/index"],
    ["Students","/admin/student/index"],
    ["Guardians","/admin/guardian/index"],
    ["Users","/admin/user/index"],
    ["User Roles","/admin/roles/index"],
    ["Permissions","/admin/permission/index/0"],
    ["Subjects","/admin/subject/index"],
    ["Quiz Envelops","/admin/envelop/quiz/index"],
    ["Task Templates","/task/template/list"],
    ["Answer Template","/answer/template/index"],
    ["Fact Book","/admin/fact/index"],
    ["Device Sync","/admin/device/sync/index"],
    ["Billing Chart","/admin/billing/index"],
    ["History","/admin/history/index"],
    ["Settings","/admin/settings/index"],
    ["Countries","/admin/countries"],
    ["Levels","/admin/levels"],
    ["Enrollments","/admin/enrolment/index"],

    ["Agent","/admin/agent/index"],
    ["Awarded","/admin/reward/award/index"],
    ["Badged","/admin/reward/badge/index"],
    ["Concepts","/admin/study/index"],
    ["Activity Types","/user/activity/type/list"],
    ["User Activities","/admin/user/activities/index"],
    ["User Last Activities","/admin/user/activity/last/index"],
    ["Messages","/admin/sent/messages/all"],
    ["Progress Email List","/admin/progress/email/list"],
    ["Search Sub Topics","/admin/search/subtopic"],
    ["Exam Structures","/admin/exam/structure/index"],
    ["Abilities","/admin/abilities"],
    ["Subscription Groups","/batch/groups/index"],
    ["Free Worksheets","/admin/free/worksheet/index"],
    ["Gifts","/admin/gifts"],
    ["Gift Categories","/admin/gift_categories"],

    ["Drill SkillS","/admin/drill_skills/index"],
    ["Drill Sub Skills","/admin/drill_sub_skills/index"],
    ["Test Image","/admin/test/image"],
    ["Test Function","/admin/test/function"],
    ["Emit Code","/admin/code/emit"]


   ]


  constructor(private adminService:AdminService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
  }
  testMailFunction(){
    this.adminService.testMailFunction().subscribe(
      x=>{
        let email =x['email']
        Swal.fire( 'Done',`Check email at ${email}` ,'info')
        return
      }
    )
  }

}
